import { GetProjectTreeProject } from 'src/model/api/get-project-tree-project.model';
import { EMPTY_PROJECT_NAMES } from 'src/utils/constants';
import { _does } from 'src/components/Planner/planner/uMath';

export function ProjectName({project}: { project: GetProjectTreeProject }) {
  return (
      <>
        {project && !_does(EMPTY_PROJECT_NAMES).contain(project) ? (
            <h3
                style={{
                  textAlign: "center",
                  wordBreak: "break-all",
                  paddingTop: 60,
                  paddingBottom: 35,
                }}
            >
              <div
                  style={{
                    fontFamily: "Open Sans",
                    fontSize: 40,
                    fontWeight: 600,
                    letterSpacing: "-0.011em",
                  }}
              >
                {project.city} {project.street_address}
              </div>
              <div
                  style={{
                    paddingTop: 21,
                    fontFamily: "Open Sans",
                    fontSize: 22,
                    fontWeight: 400,
                    letterSpacing: "-0.011em",
                  }}
              >
                {project.comment}
              </div>
            </h3>
        ) : null}
      </>)
}